import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { optionsPropTypes } from './SelectPropTypes';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import {
  clearTollLiquidationDifferenceReasons,
  getTollLiquidationDifferenceReasons,
} from '../../../../actions/route/TollLiquidation';

class TollLiquidationDifferenceReasonSelect extends Component {
  componentDidMount() {
    const { dispatchGetTollLiquidationDifferenceReasons } = this.props;
    dispatchGetTollLiquidationDifferenceReasons({ ...DEFAULT_QUERY_GET_ALL });
  }

  componentWillUnmount() {
    const { dispatchClearTollLiquidationDifferenceReasons } = this.props;
    dispatchClearTollLiquidationDifferenceReasons();
  }

  render() {
    const { reasons, isLoading, isMulti, input, meta, isDisabled } = this.props;

    return (
      <Select
        options={reasons}
        isLoading={isLoading}
        isMulti={isMulti}
        // Select expects onChange and value inside input
        input={input}
        // Select expects touched, error, warning inside meta
        meta={meta}
        isDisabled={isDisabled}
      />
    );
  }
}

TollLiquidationDifferenceReasonSelect.propTypes = {
  dispatchGetTollLiquidationDifferenceReasons: PropTypes.func.isRequired,
  dispatchClearTollLiquidationDifferenceReasons: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  reasons: optionsPropTypes,
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

TollLiquidationDifferenceReasonSelect.defaultProps = {
  isLoading: false,
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isMulti: false,
  reasons: [],
  isDisabled: false,
};

const mapStateToProps = ({ RouteUnit }) => ({
  reasons: RouteUnit.TollLiquidation.getIn([
    'differenceReason',
    'content',
    'content',
  ]).map((reason) => ({
    value: reason.id,
    label: reason.name,
  })),
  loading: RouteUnit.TollLiquidation.getIn(['differenceReason', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetTollLiquidationDifferenceReasons:
    getTollLiquidationDifferenceReasons,
  dispatchClearTollLiquidationDifferenceReasons:
    clearTollLiquidationDifferenceReasons,
};

export default connect(
  mapStateToProps,
  mapDispatchToprops,
)(TollLiquidationDifferenceReasonSelect);
